import Vue from 'vue'
import App from './App'
import router from './plugins/router'
import store from './plugins/store'
import vuetify from './plugins/vuetify'
import Vue2Editor from 'vue2-editor'

import './plugins/filters.js'

import './plugins/msg'
import './plugins/axios'
// import './plugins/print'

Vue.config.productionTip = false

Vue.use(require('vue-moment'))

Vue.directive('permission', {
  bind: function(el, binding) {
    const permissionList = store.state.permissions
    let check = false
    permissionList.forEach((rule) => {
      if (rule.restResource === binding.value) {
        if (rule.restMethod !== 'ALL' || rule.permissionType === 2) {
          el.disabled = 'disabled=disabled'
          el.classList.add('v-btn--disabled')
          el.classList.add('h-disabled')
          el.disabled = true
          check = true
        }
      }
    })
    if (check === true) {
      el.disabled = 'disabled=disabled'
      el.classList.add('v-btn--disabled')
      el.classList.add('h-disabled')
      el.disabled = true
    }
  },
})

new Vue({
  router,
  store,
  vuetify,
  Vue2Editor,
  render: (h) => h(App),
}).$mount('#app')
